import { useState, useEffect } from 'react';
import {
  Pane, Heading, Text, Button, Badge, Spinner, toaster,
  TickCircleIcon, DownloadIcon, Paragraph,
} from 'evergreen-ui';
import pagamentiService from '../../services/pagamentiService';

const MESI = [
  'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
  'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre',
];

const PagamentiCollaboratore = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await pagamentiService.getMyDocuments();
        setDocuments(data || []);
      } catch {
        toaster.danger('Errore nel caricamento dei documenti.');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleDownload = async (doc) => {
    try {
      if (!doc.letto_at) {
        await pagamentiService.markAsRead(doc.id);
        setDocuments((prev) =>
          prev.map((d) =>
            d.id === doc.id ? { ...d, letto_at: new Date().toISOString() } : d
          )
        );
      }
      const url = pagamentiService.getDownloadUrl(doc.id);
      const a = document.createElement('a');
      a.href = url;
      a.download = doc.file_name;
      a.click();
    } catch {
      toaster.danger('Errore durante il download.');
    }
  };

  const renderDoc = (doc) => (
    <Pane
      key={doc.id}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      padding={12}
      marginBottom={8}
      border="1px solid #E6E8F0"
      borderRadius={4}
      background="white"
    >
      <Pane>
        <Text fontWeight={500}>{doc.file_name}</Text>
        {doc.tipo === 'busta_paga' && doc.mese && doc.anno && (
          <Text size={300} color="muted" marginLeft={8}>
            {MESI[doc.mese - 1]} {doc.anno}
          </Text>
        )}
        <Pane display="flex" alignItems="center" marginTop={4}>
          {doc.letto_at ? (
            <>
              <TickCircleIcon color="success" size={12} marginRight={4} />
              <Text size={300} color="muted">
                Letto il {new Date(doc.letto_at).toLocaleString('it-IT')}
              </Text>
            </>
          ) : (
            <Badge color="red">Non letto</Badge>
          )}
        </Pane>
      </Pane>
      <Button
        iconBefore={doc.letto_at ? DownloadIcon : DownloadIcon}
        appearance={doc.letto_at ? 'minimal' : 'primary'}
        onClick={() => handleDownload(doc)}
      >
        {doc.letto_at ? 'Scarica' : 'Scarica e segna come letto'}
      </Button>
    </Pane>
  );

  if (loading) return <Spinner marginTop={32} />;

  const bustePaga = documents.filter((d) => d.tipo === 'busta_paga');
  const bonifici = documents.filter((d) => d.tipo === 'bonifico');

  return (
    <Pane>
      <Heading size={600} marginBottom={24}>I miei pagamenti</Heading>

      <Heading size={500} marginBottom={12}>Buste paga</Heading>
      {bustePaga.length === 0 ? (
        <Paragraph color="muted" marginBottom={24}>Nessuna busta paga disponibile.</Paragraph>
      ) : (
        <Pane marginBottom={24}>{bustePaga.map(renderDoc)}</Pane>
      )}

      <Heading size={500} marginBottom={12}>Bonifici</Heading>
      {bonifici.length === 0 ? (
        <Paragraph color="muted">Nessun bonifico disponibile.</Paragraph>
      ) : (
        <Pane>{bonifici.map(renderDoc)}</Pane>
      )}
    </Pane>
  );
};

export default PagamentiCollaboratore;
